export const environment = {

        production: false,
        apiEndpoint:"https://roar-prod-functions-hkasdjd7h8g4dhf6.eastus2-01.azurewebsites.net/",
        scopes:["api://1cd34307-20a3-4894-9717-f225accc3912/ROAR_API_ACCESS"],
        redirectUri:'https://roar-customerrefundapplication-prod.constellation.com/',
        postLogoutRedirectUri:'https://cdn-roar-prod.azureedge.net/#/log-out',
        clientid:'4071c992-1dc2-4347-a464-fb7f97a6ca2f',
        authority: 'https://login.microsoftonline.com/d8fb9c07-c19e-4e8c-a1cb-717cd3cf8ffe',
        instrumentationKey: '68d7dcdd-d579-4570-a79d-2dbcee9dd15e',
        AppInsightApiId: '35d8cb73-420f-4478-9f9a-c0b5f7f044fb',
        AppInsightApiKey: 'vctu7ih14btksmx4v1jeh6knvf4u28oeovr2u17h',
        defaultenv:"Prod",
        Settings: {
            AllowEditResponse: true,
            EnvironmentBoxText: 'LOCAL',
            EnvironmentBoxBG: 'environment-box-bg-local'
        },
        welcomeAreaColor: '#054905ff',
        welcomeAreaGradient: 'linear-gradient(rgba(89, 138, 98, 0.96), rgba(7, 167, 7, 0.3)), url(/assets/img/qbert.png)',
     }